import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { MascotBadge } from './MascotBadge';
import { ChristmasPromoCard } from './ChristmasPromoCard';
import { homeHero } from '../../data/home';
import { business } from '../../data/business';
const ease: [number, number, number, number] = [0.22, 1, 0.36, 1];
export function HomeHero() {
  return <section id="home-hero" aria-labelledby="home-hero-title" className="relative isolate w-full overflow-hidden bg-forest-900" data-id="element-324" data-mp="2wuwuy0uc7nl7">
      <img src={homeHero.background} alt={homeHero.backgroundAlt} className="absolute inset-0 -z-20 h-full w-full object-cover object-[70%_center]" data-id="element-325" data-mp="2n4boxscc3gs9" />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-forest-900/55" data-id="element-326" data-mp="2s1bywecb13on" />
      <div aria-hidden="true" className="absolute inset-y-0 left-0 -z-10 w-full bg-forest-900/30 lg:w-2/3" data-id="element-327" data-mp="3frobi2ihvolk" />

      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 pb-36 pt-14 sm:px-8 md:pt-20 lg:grid-cols-12 lg:gap-10 lg:pb-40" data-id="element-328" data-mp="3klsmcwuvsgrx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease
      }} className="lg:col-span-7" data-id="element-329" data-mp="jwnz3se6iqdg">
          <MascotBadge src={homeHero.mascotImage} alt={homeHero.mascotAlt} data-id="element-330" data-mp="swaqdld72fss" />
          <p className="mt-7 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#E3C77F]" data-id="element-331" data-mp="suzq3viyjq6f">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-332" data-mp="12n5cmpqfxfe8" />
            {homeHero.eyebrow}
          </p>
          <h1 id="home-hero-title" className="mt-4 font-display text-5xl font-medium leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-333" data-mp="1gmokdhfcaoq0">
            {homeHero.headline}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85 md:text-xl" data-id="element-334" data-mp="3ie9zfqm1pntk">{homeHero.supporting}</p>
          <div className="mt-9" data-id="element-335" data-mp="3ee9ctiosm6bf">
            <Link to={business.quoteHref} className="inline-flex h-14 items-center justify-center gap-2 rounded-full bg-[#F5C518] px-8 text-[14px] font-bold uppercase tracking-[0.08em] text-forest-900 shadow-[0_12px_30px_-12px_rgba(0,0,0,0.7)] transition-colors hover:bg-[#FFD84D] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-forest-900" data-id="element-336" data-mp="1hbsej7dk727z">
              Get Your Quote <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-337" data-mp="208k3nxfs8bjy" />
            </Link>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease,
        delay: 0.15
      }} className="mx-auto w-full max-w-md lg:col-span-5 lg:max-w-none" data-id="element-338" data-mp="29zo8437u0e0j">
          <ChristmasPromoCard data-id="element-339" data-mp="2k08e1j6aq6p3" />
        </motion.div>
      </div>
    </section>;
}